import { Box } from '@qga/roo-ui/components';

import Button from '@/components/Button';
import { useOfferModalControls } from '@/v2/components/pages/PackageView/contexts/OfferModalControlsContext';
import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import { viewOtherOptionsDataLayerEvent } from '@/v2/components/pages/PackageView/utils/dataLayer/dataLayer';
import Divider from '@/v2/components/ui/Divider';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import dataLayer from '@/v2/utils/dataLayer';

const OtherOption = () => {
  const { upgradeOffer } = useRoomOptionsData() || {};
  const { openOtherOptionModal } = useOfferModalControls();
  const shouldUseNewEvents = useGA4Events();

  return upgradeOffer ? (
    <>
      <Divider width="100%" />
      <Box data-testid="OTHER_OPTION_CTA">
        <Button
          width="100%"
          variant="primary"
          // @ts-expect-error outline is valid but not inferred correctly
          outline
          onClick={() => {
            if (shouldUseNewEvents) {
              dataLayer.ctaClickEvent({
                itemText: 'View 1 other option',
              });
            }
            viewOtherOptionsDataLayerEvent();
            openOtherOptionModal();
          }}
        >
          View 1 other option
        </Button>
      </Box>
    </>
  ) : null;
};

export default OtherOption;
